module.exports = __webpack_public_path__ + "static/media/about-us-background.132c91ee.jpg";